import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  closeIcon: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  formControl: {
    position: "relative",
    "& .MuiFormControlLabel-label": {
      width: "75%",
    },
    "&.MuiFormControlLabel-root.Mui-disabled": {
      borderStyle: "dashed",
      "& .MuiIconButton-root.Mui-disabled": {
        color: "grey",
      },
    },
  },
}));
